module.exports = __webpack_public_path__ + "static/media/1_MHN_outside.0a607bf3.jpg";